export const transformerColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '水表类型',
      type: 'input',
      placeholder: '总表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'spaceId',
      name: '片区',
      type: 'select',
      placeholder: '请选择片区',
      span: 12,
      value: 'id',
      label: 'name',
      options: ctx.spaceNameList,
    },
    {
      prop: 'meterNo',
      name: '水表编号',
      type: 'input',
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'category',
      name: '水表类别',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('water_meter_category'),
    },
    {
      prop: 'smartFlag',
      name: '是否是智能水表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      maxlength: 50,
      span: 24,
      placeholder: '请输入',
    },
  ];
};
export const unitColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '水表类型',
      type: 'input',
      placeholder: '单元水表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '水表编号',
      type: 'input',
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'category',
      name: '水表类别',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('water_meter_category'),
    },
    {
      prop: 'unitName',
      name: '单元名称',
      maxlength: 20,
      type: 'input',
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能水表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      maxlength: 50,
      span: 24,
      placeholder: '请输入',
    },
  ];
};
export const floorColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '水表类型',
      type: 'input',
      placeholder: '单元水表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '水表编号',
      type: 'input',
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'category',
      name: '水表类别',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('water_meter_category'),
    },
    {
      prop: 'floorName',
      name: '楼层名称',
      type: 'input',
      maxlength: 20,
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'smartFlag',
      name: '是否是智能水表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      maxlength: 50,
      span: 24,
      placeholder: '请输入',
    },
  ];
};
export const regionColumn = (ctx) => {
  return [
    {
      prop: 'meterType',
      name: '水表类型',
      type: 'input',
      placeholder: '变压器总表',
      span: 12,
      disabled: true,
    },
    {
      prop: 'meterNo',
      name: '水表编号',
      type: 'input',
      placeholder: '请输入',
      span: 12,
    },
    {
      prop: 'category',
      name: '水表类别',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('water_meter_category'),
    },
    {
      prop: 'smartFlag',
      name: '是否是智能水表',
      type: 'select',
      placeholder: '请选择',
      span: 12,
      options: ctx.$baseRequest.getDictListMapByType('smartFlag'),
    },
    {
      prop: 'meterReadingWarning',
      name: '抄表预警',
      type: 'inputAmount',
      precision: 2,
      max: 999999999,
      placeholder: '请选择',
      span: 12,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      maxlength: 50,
      span: 24,
      placeholder: '请输入',
    },
  ];
};
